import axios from "axios";
import formats from "../utils/formats";
import restaurantClient from "./restaurant";

const MANIFEST_ENDPOINT = "https://mycia-mcm.s3.eu-central-1.amazonaws.com/:token/manifest.json";
const RESTAURANT_ENDPOINT = "https://mycia-mcm.s3.eu-central-1.amazonaws.com/:token/:lang/:consumetime/:filename";

async function fetchRestaurantData(lang, token) {
    let manifest;
    try {
        const manifestUrl = formats.formatUrl(MANIFEST_ENDPOINT, { token });
        const manifestUrlWithoutCache = `${manifestUrl}?t=${Date.now()}`;
        const manifestResp = await axios.get(manifestUrlWithoutCache);
        manifest = manifestResp.data;
    } catch (err) {
        throw err;
    }

    const restaurantFile = manifest?.restaurant;
    if (!restaurantFile) {
        throw new Error("restaurant key not found in manifest.");
    }

    const consumetime = formats.getConsumeTime(token);

    const restaurantUrl = formats.formatUrl(RESTAURANT_ENDPOINT, {
        token,
        lang,
        consumetime,
        filename: restaurantFile,
    });

    try {
        const response = await axios.get(restaurantUrl);
        return response.data;
    } catch (error) {
        throw error;
    }
}

async function doGet(lang, token) {
    try {
        const restaurantData = await fetchRestaurantData(lang, token);
        return restaurantData.data;
    } catch {
        // Fallback to legacy restaurantClient
        return await restaurantClient.doGet(lang, token);
    }
}

const restaurantV2 = {
    doGet,
};

export default restaurantV2;
